import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import classnames from "classnames";
import { useIsDesktop } from "../../hooks/index.js";
import { Box } from "../../Box/index.js";
import { Typography } from "../../Typography/index.js";
import { Tooltip } from "../../Tooltip/index.js";
import { Icon } from "../../Icon/index.js";
import { Label } from "../common/index.js";
import { useStyles } from "./RadioInput.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function RadioInput_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else RadioInput_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const RadioInput = (t0)=>{
    const $ = c(67);
    let error;
    let helperText;
    let items;
    let label;
    let labelIcon;
    let onChange;
    let rest;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let t6;
    let testId;
    let value;
    if ($[0] !== t0) {
        ({ items, label, labelIcon, labelPlacement: t1, value, onChange, required: t2, row: t3, tooltip: t4, disabled: t5, testId, withoutMargins: t6, error, helperText } = t0), rest = _object_without_properties(t0, [
            "items",
            "label",
            "labelIcon",
            "labelPlacement",
            "value",
            "onChange",
            "required",
            "row",
            "tooltip",
            "disabled",
            "testId",
            "withoutMargins",
            "error",
            "helperText"
        ]);
        $[0] = t0;
        $[1] = error;
        $[2] = helperText;
        $[3] = items;
        $[4] = label;
        $[5] = labelIcon;
        $[6] = onChange;
        $[7] = rest;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
        $[13] = t6;
        $[14] = testId;
        $[15] = value;
    } else {
        error = $[1];
        helperText = $[2];
        items = $[3];
        label = $[4];
        labelIcon = $[5];
        onChange = $[6];
        rest = $[7];
        t1 = $[8];
        t2 = $[9];
        t3 = $[10];
        t4 = $[11];
        t5 = $[12];
        t6 = $[13];
        testId = $[14];
        value = $[15];
    }
    const labelPlacement = void 0 === t1 ? "end" : t1;
    const required = void 0 === t2 ? false : t2;
    const row = void 0 === t3 ? false : t3;
    const tooltip = void 0 === t4 ? null : t4;
    const disabled = void 0 === t5 ? false : t5;
    const withoutMargins = void 0 === t6 ? false : t6;
    const isDesktop = useIsDesktop();
    const { classes } = useStyles();
    const t7 = error && helperText && classes.groupMargin;
    let t8;
    if ($[16] !== t7) {
        t8 = classnames("aqa_radion_input", t7);
        $[16] = t7;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== label || $[19] !== labelIcon || $[20] !== required || $[21] !== tooltip) {
        t9 = label && /*#__PURE__*/ jsx(Label, {
            label: label,
            required: required,
            tooltip: tooltip,
            icon: labelIcon
        });
        $[18] = label;
        $[19] = labelIcon;
        $[20] = required;
        $[21] = tooltip;
        $[22] = t9;
    } else t9 = $[22];
    const t10 = isDesktop || row;
    let t11;
    if ($[23] !== onChange) {
        t11 = (e)=>{
            onChange(e.target.value);
        };
        $[23] = onChange;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== classes.root) {
        t12 = {
            root: classes.root
        };
        $[25] = classes.root;
        $[26] = t12;
    } else t12 = $[26];
    const t13 = !error && classes.groupMargin;
    const t14 = withoutMargins && classes.withoutMargins;
    const t15 = row && "top" === labelPlacement && classes.labelTopRow;
    const t16 = error && classes.error;
    let t17;
    if ($[27] !== t13 || $[28] !== t14 || $[29] !== t15 || $[30] !== t16) {
        t17 = classnames("aqa_radioinput_block", t13, t14, t15, t16);
        $[27] = t13;
        $[28] = t14;
        $[29] = t15;
        $[30] = t16;
        $[31] = t17;
    } else t17 = $[31];
    let t18;
    if ($[32] !== classes.checked || $[33] !== classes.disabled || $[34] !== classes.inputRoot || $[35] !== classes.itemRoot || $[36] !== classes.label || $[37] !== classes.labelTop || $[38] !== items || $[39] !== labelPlacement) {
        let t19;
        if ($[41] !== classes.checked || $[42] !== classes.disabled || $[43] !== classes.inputRoot || $[44] !== classes.itemRoot || $[45] !== classes.label || $[46] !== classes.labelTop || $[47] !== labelPlacement) {
            t19 = (item)=>{
                if (item.tooltip && item.disabled) return /*#__PURE__*/ jsx(Tooltip, {
                    title: item.tooltip,
                    placement: "bottom",
                    children: /*#__PURE__*/ jsx(Box, {
                        children: /*#__PURE__*/ jsx(FormControlLabel, {
                            value: item.value,
                            disabled: item.disabled,
                            classes: {
                                root: classnames(classes.itemRoot, "top" === labelPlacement && classes.labelTop),
                                label: classes.label,
                                disabled: classes.disabled
                            },
                            control: /*#__PURE__*/ jsx(Radio, {
                                disableRipple: true,
                                disableFocusRipple: true,
                                disableTouchRipple: true,
                                classes: {
                                    root: classes.inputRoot,
                                    checked: classes.checked
                                },
                                icon: /*#__PURE__*/ jsx(Icon, {
                                    name: "radio_off",
                                    size: "24",
                                    color: "stroke.primary"
                                }),
                                checkedIcon: /*#__PURE__*/ jsx(Icon, {
                                    name: "radio_on",
                                    size: "24"
                                })
                            }),
                            label: /*#__PURE__*/ jsx(Box, {
                                mr: "start" === labelPlacement ? "8" : "0",
                                ml: "end" === labelPlacement ? "8" : "0",
                                children: /*#__PURE__*/ jsx(Typography, {
                                    color: "text.light.secondary",
                                    variant: "body3",
                                    children: item.label
                                })
                            }),
                            labelPlacement: labelPlacement
                        }, item.value)
                    }, item.value)
                }, item.label);
                return /*#__PURE__*/ jsx(Box, {
                    children: /*#__PURE__*/ jsx(FormControlLabel, {
                        value: item.value,
                        disabled: item.disabled,
                        classes: {
                            root: classnames(classes.itemRoot, "top" === labelPlacement && classes.labelTop),
                            label: classes.label,
                            disabled: classes.disabled
                        },
                        control: /*#__PURE__*/ jsx(Radio, {
                            disableRipple: true,
                            disableFocusRipple: true,
                            disableTouchRipple: true,
                            classes: {
                                root: classes.inputRoot,
                                checked: classes.checked
                            },
                            icon: /*#__PURE__*/ jsx(Icon, {
                                name: "radio_off",
                                size: "24",
                                color: "stroke.primary"
                            }),
                            checkedIcon: /*#__PURE__*/ jsx(Icon, {
                                name: "radio_on",
                                size: "24"
                            })
                        }),
                        label: /*#__PURE__*/ jsx(Box, {
                            mr: "start" === labelPlacement ? "8" : "0",
                            ml: "end" === labelPlacement ? "8" : "0",
                            children: /*#__PURE__*/ jsx(Typography, {
                                color: "text.light.secondary",
                                variant: "body3",
                                children: item.label
                            })
                        }),
                        labelPlacement: labelPlacement
                    }, item.value)
                }, item.value);
            };
            $[41] = classes.checked;
            $[42] = classes.disabled;
            $[43] = classes.inputRoot;
            $[44] = classes.itemRoot;
            $[45] = classes.label;
            $[46] = classes.labelTop;
            $[47] = labelPlacement;
            $[48] = t19;
        } else t19 = $[48];
        t18 = items.map(t19);
        $[32] = classes.checked;
        $[33] = classes.disabled;
        $[34] = classes.inputRoot;
        $[35] = classes.itemRoot;
        $[36] = classes.label;
        $[37] = classes.labelTop;
        $[38] = items;
        $[39] = labelPlacement;
        $[40] = t18;
    } else t18 = $[40];
    let t19;
    if ($[49] !== rest || $[50] !== t10 || $[51] !== t11 || $[52] !== t12 || $[53] !== t17 || $[54] !== t18 || $[55] !== testId || $[56] !== value) {
        t19 = /*#__PURE__*/ jsx(RadioGroup, _object_spread_props(_object_spread({}, rest), {
            "data-testid": testId,
            row: t10,
            value: value,
            onChange: t11,
            classes: t12,
            className: t17,
            children: t18
        }));
        $[49] = rest;
        $[50] = t10;
        $[51] = t11;
        $[52] = t12;
        $[53] = t17;
        $[54] = t18;
        $[55] = testId;
        $[56] = value;
        $[57] = t19;
    } else t19 = $[57];
    let t20;
    if ($[58] !== error || $[59] !== helperText) {
        t20 = error && /*#__PURE__*/ jsx(Box, {
            mt: "4",
            children: /*#__PURE__*/ jsx(Typography, {
                variant: "caption",
                color: "accent.text.error",
                children: helperText
            })
        });
        $[58] = error;
        $[59] = helperText;
        $[60] = t20;
    } else t20 = $[60];
    let t21;
    if ($[61] !== disabled || $[62] !== t19 || $[63] !== t20 || $[64] !== t8 || $[65] !== t9) {
        t21 = /*#__PURE__*/ jsxs(FormControl, {
            className: t8,
            component: "fieldset",
            disabled: disabled,
            children: [
                t9,
                t19,
                t20
            ]
        });
        $[61] = disabled;
        $[62] = t19;
        $[63] = t20;
        $[64] = t8;
        $[65] = t9;
        $[66] = t21;
    } else t21 = $[66];
    return t21;
};
export { RadioInput };
